import React, { FC } from 'react'
import LayoutDefault from '@/components/layouts/Layout'
import { SectionHeader, ServiceItem } from '@/components/modules'

const ServicePage: FC = () => {
  return (
    <LayoutDefault image='https://twinsynergy.co.th/images/social-services.webp'>
      <SectionHeader
        title='services'
        bgColors='#1990FF'
        bgImage='/images/default_banner_header.webp'
        bgImageSm='/images/default_banner_header-sm.webp'
        bgImageWidth={1214}
        bgImageHeight={534}
      />
      <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4'>
        <ServiceItem
          prologue='01'
          title='พัฒนาเว็บไซต์'
          serviceImg='/images/service/service-01.webp'
          serviceBg='#06B7B7'
          serviceUrl='website-development'
        />
        <ServiceItem
          prologue='02'
          title='พัฒนาแอปพลิเคชั่นมือถือ'
          serviceImg='/images/service/service-02.webp'
          serviceBg='#1990FF'
          serviceUrl='mobile-application-development'
        />
        <ServiceItem
          prologue='03'
          title='ออกแบบเว็บไซต์'
          serviceImg='/images/service/service-03.webp'
          serviceBg='#FFCA64'
          serviceUrl='website-design'
        />
        <ServiceItem
          prologue='04'
          title='เว็บไซต์สำหรับธุรกิจ SME'
          serviceImg='/images/service/service-04.webp'
          serviceBg='#FFAC79'
          serviceUrl='sme-website-development'
        />
        <ServiceItem
          prologue='05'
          title='ออกแบบและพัฒนา Line OA'
          serviceImg='/images/service/service-05.webp'
          serviceBg='#00BE00'
          serviceUrl='line-oa-development'
        />
        <ServiceItem
          prologue='06'
          title='พัฒนาซอฟต์แวร์ตามกำหนด'
          serviceImg='/images/service/service-06.webp'
          serviceBg='#FF7D7D'
          serviceUrl='custom-software-development'
        />
        <ServiceItem
          prologue='07'
          title='เพิ่มความปลอดภัย'
          serviceImg='/images/service/no-service.webp'
          serviceBg='#B577E5'
          noLink
        />
        <ServiceItem
          prologue='08'
          title='ดูแลบำรุงรักษาเว็บไซต์'
          serviceImg='/images/service/no-service.webp'
          serviceBg='#484848'
          noLink
        />
      </div>
    </LayoutDefault>
  )
}

export default ServicePage
